export default [
    {
        exp_id: 'Experiment_8'
    },
    {
        exp_id: 'Experiment_7'
    },
    {
        exp_id: 'Experiment_9'
    },
    {
      exp_id: 'Experiment_10'
    },
    {
        exp_id: 'Experiment_11'
    },
    {
        exp_id: 'Experiment_12'
    },
]


export const EXPERIMENT_STATUSES = {
    EXPERIMENT_NOT_FOUND: "EXPERIMENT_NOT_FOUND",
    NO_PROFILE_MATCH: "NO_PROFILE_MATCH",
    NEW_ASSIGNMENT: "NEW_ASSIGNMENT",
    EXISTING_ASSIGNMENT: "EXISTING_ASSIGNMENT"
}
